<template>
  <v-flex xs12 sm5 lg3 xl2>
    <v-layout justify-center row>
      <v-card class="ma-2" :width="200">
        <v-layout justify-center row>
          <img class="image-circle mt-2" :src="imageRender" :alt="`Foto de ${student.name}`">
        </v-layout>

        <v-card-title primary-title>
          <v-layout justify-center row>
            <h3 class="headline mb-0 text-truncate text-xs-center">{{ student.name }}</h3>
          </v-layout>
        </v-card-title>

        <v-card-actions>
          <v-layout justify-center row>
            <v-btn
              color="primary"
              @click="$emit('click', student.id)">
                {{ button_label }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-flex>
</template>

<script>
/**
 * @group Meal Control
 * Gera os cards no index da funcionalidade MealControl para a seleção do aluno
 * que será exibido as bandejas.
 */
export default {
  name: 'StudentCard',

  props: {
    // Dados do estudante
    student: {
      type: Object,
      // {}
      default () {
        return {}
      }
    },

    button_label: {
      type: String,
      required: true
    }
  },

  computed: {
    imageRender () {
      return (
        this.student.picture_path || require('@/assets/images/placeholders/user.png')
      )
    }
  }
}
</script>
